<!-- <span (click)="openModal('lg')">
  <i
    class="fa fa-lg fa-fw cursor-pointer"
    [ngClass]="icon"
    matTooltip="View SSID History"
    matTooltipPosition="above">
  </i>
</span> -->
<button type="button" mat-icon-button (click)="openModal()" *ngIf="type=== 'btn' || !type"
	matTooltip="View SSID History" matTooltipPosition="above">
	<mat-icon>history</mat-icon>
</button>

<mat-icon class="cursor-pointer" (click)="openModal()" *ngIf="type === 'icon'" matTooltip="View SSID History"
	matTooltipPosition="above">
	history
</mat-icon>